<template>
  <div class="container">
    <div class="mt40">
      <p>棚卸対象ファイルをアップロード(CSV形式)します。<br>
      内容を入力してアップロードしてください。（<span class="hissu">*</span>印は必須項目です。）</p>
    </div>
    <table class="table mt40">
      <tbody>
        <tr>
          <td class="w200">棚卸識別名<span class="hissu" v-if="isRequired('inventoryIdentyName')">*</span></td>
          <td>
            <ValidationProvider v-slot="{ errors }" rules="required|max:50" ref="observer">
              <input id="inventoryIdentyName" type="text" class="form-control enterp-codeInput" :name="itemName.inventoryName"
                v-model="invName" @change="changeInvName" autocomplete="off"/>
              <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
            </ValidationProvider>
          </td>
        </tr>
      </tbody>
    </table>
    <RfidFileUploadArea ref="fileDropArea" btnName="アップロード"
      v-on:btn-click="execute" v-bind:btnDisable="true">
      <template v-slot:caption>
        ここにCSVファイルをドロップ<br />または、選択してください。<br />
      </template>
    </RfidFileUploadArea>
    <!-- 処理中アイコン -->
    <Loading v-show="isLoading"></Loading>
    <br>
    <br>
  </div>
</template>

<script>
import RfidFileUploadArea from '@/components/atoms/RfidFileUploadArea'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Loading from '@/components/atoms/Loading'
export default {
  name: 'enterprise-list',
  components: {
    RfidFileUploadArea,
    ValidationObserver,
    ValidationProvider,
    Loading
  },

  data () {
    return {
      mode: 'entry',
      screenTitle: '[棚卸対象ファイル管理] 棚卸対象ファイルアップロード',
      selectedFileName: '',
      invName: '',
      isUploaded: false,
      itemName: {},
      entity: {
        enterpriseCode: null,
        enterpriseName: null,
        enterpriseAuthCode: null,
        enterpriseAuthPass: null,
        domain: null,
        licenseStartDate: null,
        licenseEndDate: null,
        licenseType: 0,
        businessType: 0,
        manualInventoryPermitDiv: 0,
        simpleAuthenticationDiv: 0,
        inventoryDeleteDiv: 0,
        inventoryCancelDiv: 0,
        accountbookDiv: 0
      },
      isLoading: false
    }
  },

  async created () {
    this.$emit('setMessage', null, false)
    this.permissionData = this.permission().stockFileUpload[this.mode]
    this.itemName = this.item()
    var params = {
      enterpriseCode: this.$session.get('enterpriseCode'),
      enterpriseCreateDateFrom: '',
      enterpriseCreateDateTo: ''
    }
    // 企業情報操作（取得）API
    var response = await this.axios.get('/api/enterprise/get', {
      params: params,
      headers: {
        'Authorization': this.$session.get('accessToken'),
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }
    })
    this.entity = response.data[0]
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  updated () {
    this.refresh()
  },

  methods: {
    isRequired (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === ''
    },

    changeInvName () {
      this.refresh()
    },

    // ファイル選択部品からの呼び出し処理
    async execute (file) {
      try {
        // 処理中アイコン表示
        this.isLoading = true
        if (file !== undefined) {
          await this.readFile(file)
            .then(str => this.sendCsvData(str))
        } else {
          this.refresh()
        }
      } catch (ex) {
        throw ex
      } finally {
        // 処理中アイコン非表示
        this.isLoading = false
      }
    },

    // 棚卸識別名と選択したファイルの両方が揃った時にアップロードボタンを有効にする
    async refresh () {
      const isValid = await this.$refs.observer.validate()
      if (this.$refs.fileDropArea.getFileName() !== '' && this.invName !== '' && isValid.valid) {
        if (this.entity.accountbookDiv === 0) {
          this.isUploadStanby = true
          this.$refs.fileDropArea.btnDisable = false
        } else if (this.entity.accountbookDiv === 1) {
          this.isUploadStanby = false
          this.$refs.fileDropArea.btnDisable = true
        }
      } else {
        this.isUploadStanby = false
        this.$refs.fileDropArea.btnDisable = true
      }
    },

    // 選択されたデータファイルの読み込み
    readFile (file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        // 読み込みが完了したら中身を取り出す
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    // Base64エンコードしてAPI呼び出し
    async sendCsvData (str) {
      this.$emit('setMessage', null, false)
      var base64str = btoa(
        new Uint8Array(str).reduce((data, byte) => data + String.fromCharCode(byte), '')
      )
      console.log('★Base64 btoa()')
      console.log(base64str)
      await this.axios.post('/api/inventory/file/upload', {
        inventoryName: this.invName,
        binaryData: base64str
      }, {
        headers: {
          'Authorization': this.$session.get('accessToken')
        }
      }).then((response) => {
        this.setUpadloadedStatus(true)
        console.log(response.data)
      })
    },

    setUpadloadedStatus (status) {
      this.$refs.fileDropArea.setOkMessage('アップロード処理が完了しました。')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/StockFileUpload.vue